import {
    C1AutocompleteSingleAsync,
    C1AutocompleteSingleAsyncHook,
    C1AutocompleteSingleAsyncProps,
    Searchable,
} from 'components/core/autocomplete'
import { Requestable, NonRequestable } from 'components/core/autocomplete/C1AutocompleteSingleAsync'
import { AllowedRefs } from 'lib/websocket-notify'
import React, { ComponentProps } from 'react'

// just for convenience...
export type RenderedSelectOneProps<T extends Searchable> = Omit<C1AutocompleteSingleAsyncProps<T>, 'renderOption'>

export type SelectOneHookProps<Request extends NonRequestable | Requestable<AllowedRefs>, T extends Searchable> =
    Omit<ComponentProps<typeof C1AutocompleteSingleAsyncHook<Request, T>>, 'Req' | 'hook' | 'renderOption' | 'renderLabel' | 'initialValue' | 'type'>

export const renderLabel = (option: Searchable): string => {
    return option.displayName || option.id || 'unknown'
}

export const SelectOne = <T extends Searchable>({ ...rest }: C1AutocompleteSingleAsyncProps<T>): React.ReactElement => {
    return <C1AutocompleteSingleAsync {...rest} />
}
